import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import moment from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import saveAs from 'file-saver';
import { NotificationService } from '../shared/services/notification.sevice';
import { PaymentRequestTaskService, BillingReportTasks, BillingReport } from '../shared/_generated/backend';

export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY'
    },
    display: {
        dateInput: 'YYYY.MM.',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

@Component({
    selector: 'app-billing-report',
    templateUrl: './billing-report.component.html',
    styleUrl: './billing-report.component.scss',
    standalone: false,
    providers: [
        provideMomentDateAdapter(MY_FORMATS)
    ]
})
export class BillingReportComponent implements OnInit {
    @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);
    @ViewChild(MatSort) sort: MatSort = new MatSort();

    form = this.formBuilder.group({
        month: new FormControl(moment().subtract(1, 'month').toISOString(), Validators.required)
    });

    displayedColumns: string[] = [
        'creationDateTime',
        'type',
        'payer',
        'amount',
        'comment',
        'status'
    ];
    sum = 0;
    dataSource: MatTableDataSource<BillingReportTasks> = new MatTableDataSource();
    isLoading = false;

    constructor(
        private paymentRequestTaskService: PaymentRequestTaskService,
        public dialog: MatDialog,
        private notifier: NotificationService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit(): void {
        this.getBillingReport();
    }

    setMonthAndYear(date: string, datepicker: MatDatepicker<moment.Moment>) {
        this.form.controls.month.setValue(date);
        datepicker.close();
    }

    getBillingReport() {
        const month = moment(this.form.controls.month.value).format('YYYYMM');
        this.isLoading = true;
        this.paymentRequestTaskService.getBillingReport('application/json', month).subscribe({
            next: result => {
                const report = result as BillingReport;
                this.sum = report.sum;
                this.dataSource = new MatTableDataSource(report.tasks);
                this.dataSource.filterPredicate =
          (task, filter) => task.type.trim().toLowerCase().includes(filter);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            },
            complete: () => {
                this.isLoading = false;
            },
            error: () => {
                this.notifier.showErrorSnackBar('Váratlan hiba.');
            }
        });

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
    }

    async getPaymentRequests() {
        const month = moment(this.form.controls.month.value).format('YYYYMM');
        this.isLoading = true;
        this.paymentRequestTaskService.getBillingReport('text/csv', month).subscribe({
            next: result => {
                const report = result as string;
                const fileName = `${new Date().getTime()}_paymentrequests.csv`;
                const data: Blob = new Blob([report], {});
                saveAs(data, fileName);
            },
            complete: () => {
                this.isLoading = false;
            },
            error: () => {
                this.notifier.showErrorSnackBar('Váratlan hiba.');
            }
        });
    }
}
